import { render } from "./Actuality.vue?vue&type=template&id=6d65278c&scoped=true"
import script from "./Actuality.vue?vue&type=script&lang=js"
export * from "./Actuality.vue?vue&type=script&lang=js"

import "./Actuality.vue?vue&type=style&index=0&id=6d65278c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d65278c"]])

export default __exports__